import styled from 'styled-components';
import { COLORS } from '../../../colors';

const StyledHeader = styled.header`
    text-align: center;
    background-color: ${COLORS.darkerBlue};
    .header-desktop {
        padding: 0.5rem;
        display: none;
        @media only screen and (min-width: 600px) {
            max-width: 1200px;
            margin: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        select.language-select {
            margin-left: 1rem;
            padding: 5px;
            border-radius: 4px;
            border: 1px solid ${COLORS.lightGray};
            background-color: ${COLORS.darkBlue};
            color: ${COLORS.white};
        }
        .elements {
            display: flex;
            align-items: center;
            gap: 1rem;
            a {
            font-size: 16px;
            text-decoration: none;
            font-weight: bold;
            color: ${COLORS.white};
            }
            a:hover, a.active {
            font-weight: bold;
            color: ${COLORS.primary};
            }
            div.tokens {
            color: ${COLORS.primary};
            padding: 0.5rem 1.5rem;
            width: fit-content;
            border-radius: 12px;
            margin-left: 1rem;
            p {
                font-size: 14px;
                font-weight: bold;
            }
        }
        button.ai-tools {
            font-size: 16px;
            font-weight: bold;
            color: ${COLORS.white};
            border: none;
            background-color: transparent;
            svg {
                margin-right: 5px;
            }
        }
        }
        img {
            width: 40px;
        }
        }
}
    .sub-header-desktop {
        padding: 1rem;
        display: flex;
        justify-content: center;
        gap: 1rem;
        background-color: ${COLORS.darkBlueAlternative};
        a {
        font-size: 16px;
        text-transform: uppercase;
        text-decoration: none;
        color: black;
        font-weight: bold;
        color: ${COLORS.lightGray};
        }
        a:hover, a.active {
        font-weight: bold;
        color: ${COLORS.primary};
        }
    }
    .header-mobile {
        padding: 0.5rem;
        .icons {
        display: flex;
        justify-content: space-between;
        img {
            width: 40px;
            padding: 3px;
        }
        button#hamburger {
            border: none;
            background-color: transparent;
            img {
                width: 30px;
            }
        }
        }
        @media only screen and (min-width: 600px) {
        display: none;
        }
        .elements {
            display: flex;
            flex-direction: column;
            position: absolute;
            background-color: ${COLORS.darkerBlue};
            width: 100%;
            left: 0;
            z-index: 99;
            display: flex;
            flex-direction: column;
        a {
            margin-bottom: 1rem;
            font-size: 18px;
            text-transform: uppercase;
            font-weight: bold;
            text-decoration: none;
            color: ${COLORS.white};
        }
        }
    }
`;

export {
    StyledHeader
}
